import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { ReleaseNote } from '../release-notes';
import { navigatesInPlace, ReleaseNotesList } from '../release-notes-list/release-notes-list';

/** What is new since the user last looked: the unseen releases, newest first, one list each. */
@Component({
  selector: 'app-release-notes-dialog',
  imports: [MatButton, MatDialogActions, MatDialogContent, MatIcon, ReleaseNotesList, RouterLink],
  templateUrl: './release-notes-dialog.html',
})
export class ReleaseNotesDialog {
  readonly dialogRef = inject(MatDialogRef<ReleaseNotesDialog>);
  readonly notes = inject<ReleaseNote[]>(MAT_DIALOG_DATA);

  protected closeIfInPlace(event: MouseEvent): void {
    if (navigatesInPlace(event)) this.dialogRef.close();
  }
}
